module.exports = __webpack_public_path__ + "static/media/cardA.57c6276e.svg";